import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MarkEmailReadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mark_email_read"}/>
}
